// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8fa1af5d","455":"07fbc272","488":"80dbaaa6"}[chunkId] + ".chunk.js";
};